const BASE_URL = 'https://api.dev.auxo.dk/public/content';

export async function fetchProjects() {
  try {
    const response = await fetch(`${BASE_URL}/projects`);
    if (!response.ok) throw new Error(`Failed to fetch projects: ${response.status}`);
    const data = await response.json();
    console.log('Fetched projects:', data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
}

export async function fetchProjectBySlug(lang, slug) {
  try {
    const response = await fetch(`https://api.dev.auxo.dk/public/by-slug/${lang}/${slug}`);
    if (!response.ok) throw new Error('Failed to fetch project');
    return await response.json();
  } catch (error) {
    console.error('Error fetching project by slug:', error);
    return null;
  }
}
